import useOnlineStatus from 'hooks/useOnlineStatus';
import NetworkErrorComponent from 'pages/Errorpages/NetworkErrorComponent';
import React, { memo } from 'react';
import { Navigate } from 'react-router-dom';
import { PATH } from 'utils/pagePath';
import { getToken } from 'utils/utils';

const PublicRoute = ({ component: Component }) => {
    const isOnline = useOnlineStatus();
    const appType = process.env.REACT_APP_APP_TYPE;
    const defaultRedirect =
        appType === "PMT"
            ? PATH.PROJECTS
            : PATH.SUPPORT_PORTAL;

    return !getToken()
        ? isOnline
            ? Component
            : <NetworkErrorComponent />
        : <Navigate to={defaultRedirect} replace />;
};

export default memo(PublicRoute);
